// 数据翻译
export function selectDictLabel(datas, value) {
	var actions = [];
	Object.keys(datas).map((key) => {
	  if (datas[key].value == value) {
		actions.push(datas[key].label);
		return false;
	  }
	})
	return actions.join('');
  }

export const genderList = [{
	value: 1,
	label: '男'
},{
	value: 2,
	label: '女'
}]

export const projectType = [
	{
		value: 0,
		label: '新建'
	},
	{
		value: 1,
		label: '改扩建'
	},
	{
		value: 2,
		label: '改造'
	}
]